import { render, staticRenderFns } from "./GalleryPage.vue?vue&type=template&id=2ef8946e&scoped=true&"
import script from "./GalleryPage.vue?vue&type=script&lang=js&"
export * from "./GalleryPage.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPage.vue?vue&type=style&index=0&id=2ef8946e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef8946e",
  null
  
)

export default component.exports